// extracted by mini-css-extract-plugin
export var attachmentContainer = "_mp-0";
export var fileList = "_mp-2";
export var removeFileButton = "_mp-1";